export function getPathArray(path: string | string[]): string[] {
  return Array.isArray(path) ? path.flatMap(getPathArray) : path.match(/([^[.\]])+/g) || []
}

export function getValue<T extends object = any, V = any>(obj: T, path: string | string[]): V {
  return getPathArray(path)?.reduce((acc: any, key) => acc?.[key], obj)
}
